import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Play } from 'lucide-react';
import SongMenu from '../SongMenu';

const GenrePage = ({ playSong, songs, user }) => {
  const { genreSlug } = useParams();
  const [genre, setGenre] = useState(null);
  const [genreSongs, setGenreSongs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGenreData = async () => {
      try {
        // Fetch genre details
        const genreResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/genres`);
        if (genreResponse.ok) {
          const genres = await genreResponse.json();
          const foundGenre = genres.find(g => g.slug === genreSlug);
          setGenre(foundGenre);
        }
        
        // Filter songs by genre and randomize order for variety
        const filtered = songs.filter(song => 
          song.genre && song.genre.toLowerCase() === genreSlug.toLowerCase()
        );
        const randomized = filtered.sort(() => Math.random() - 0.5);
        setGenreSongs(randomized);
      } catch (error) {
        console.error('Failed to fetch genre data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGenreData();
  }, [genreSlug, songs]);

  if (loading) {
    return (
      <div className="page-content">
        <div className="page-header">
          <h1>Loading...</h1>
        </div>
      </div>
    );
  }

  if (!genre) {
    return (
      <div className="page-content">
        <div className="page-header">
          <h1>Genre Not Found</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="page-header" style={{ marginBottom: '32px' }}>
        <div>
          <h1 style={{ fontSize: '48px', fontWeight: 'bold', marginBottom: '8px' }}>
            {genre.name}
          </h1>
          <p style={{ color: '#999', fontSize: '16px' }}>
            {genre.description || `Explore ${genre.name} music`} • {genreSongs.length} songs
          </p>
        </div>
        {genreSongs.length > 0 && (
          <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
            <button 
              className="play-all-button"
              onClick={() => playSong(genreSongs[0], genreSongs)}
              style={{
                background: '#9D4EDD',
                color: 'white',
                border: 'none',
                borderRadius: '24px',
                padding: '12px 24px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              <Play size={20} fill="white" />
              Play All
            </button>
          </div>
        )}
      </div>

      {genreSongs.length === 0 ? (
        <div style={{ 
          textAlign: 'center', 
          padding: '64px 24px',
          color: '#999'
        }}>
          <p style={{ fontSize: '18px' }}>No songs available in this genre yet</p>
        </div>
      ) : (
        <div className="songs-grid">
          {genreSongs.map(song => (
            <div key={song.id} className="song-card">
              <div className="song-card-image">
                <img src={song.albumArt || song.album_art_url} alt={song.title} />
                <SongMenu song={song} user={user} />
                <button 
                  className="play-button"
                  onClick={() => playSong(song, genreSongs)}
                >
                  <Play size={20} fill="white" />
                </button>
              </div>
              <div className="song-card-content">
                <h3 className="song-title">{song.title}</h3>
                <p className="song-artist">{song.artist}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GenrePage;